import Vue from 'vue'
import App from './App.vue'

// Get all the plugins and configure them
import * as plugins from './plugins'
import './plugins/configure'

import router from './router'

import './publish/pwa/registerServiceWorker'

Vue.config.productionTip = false

new Vue({
  ...plugins,

  // Plugins / Vendors
  i18n: plugins.locale.i18n,

  router,
  render: h => h(App)
}).$mount('#app')
